export interface Resource {
  id: string;
  name: string;
  version: string;
  size: string;
  category: string;
  rating: number;
  downloads: number;
  description: string;
  platform: string[];
  icon: string;
  updateDate: string;
}

export const resources: Resource[] = [
  {
    id: 'res-001',
    name: 'CleanMaster Pro 2024',
    version: 'v6.8.2',
    size: '45.2 MB',
    category: 'system-tools',
    rating: 4.8,
    downloads: 236000,
    description: '专业级系统清理优化工具，深度清理垃圾文件、注册表冗余，提升电脑运行速度高达300%',
    platform: ['Windows', 'macOS'],
    icon: 'ri-brush-4-line',
    updateDate: '2026-07-28',
  },
  {
    id: 'res-002',
    name: 'WPS Office 2024 专业版',
    version: 'v12.8.0',
    size: '186.5 MB',
    category: 'office-software',
    rating: 4.9,
    downloads: 512000,
    description: '国产办公套件，完美兼容Word、Excel、PPT格式，内置海量模板和AI写作助手',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-file-word-2-line',
    updateDate: '2026-08-01',
  },
  {
    id: 'res-003',
    name: 'Adobe Photoshop 2024',
    version: 'v25.4.0',
    size: '2.8 GB',
    category: 'graphic-design',
    rating: 4.9,
    downloads: 389000,
    description: '全球最强大的图像处理和设计软件，支持AI智能抠图、神经滤镜等前沿功能',
    platform: ['Windows', 'macOS'],
    icon: 'ri-image-edit-line',
    updateDate: '2026-07-30',
  },
  {
    id: 'res-004',
    name: '剪映专业版',
    version: 'v5.8.0',
    size: '623.8 MB',
    category: 'video-editing',
    rating: 4.7,
    downloads: 678000,
    description: '抖音官方出品视频剪辑工具，海量素材模板、AI智能字幕、一键成片功能',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-video-line',
    updateDate: '2026-08-03',
  },
  {
    id: 'res-005',
    name: 'Visual Studio Code',
    version: 'v1.92.0',
    size: '88.3 MB',
    category: 'dev-tools',
    rating: 4.9,
    downloads: 892000,
    description: '微软开源免费代码编辑器，丰富插件生态，支持几乎所有编程语言的智能开发',
    platform: ['Windows', 'macOS', 'Linux'],
    icon: 'ri-terminal-box-line',
    updateDate: '2026-08-05',
  },
  {
    id: 'res-006',
    name: '原神',
    version: 'v5.2.0',
    size: '72.5 GB',
    category: 'games',
    rating: 4.6,
    downloads: 1250000,
    description: '米哈游开放世界冒险游戏，精美画面、丰富剧情、自由探索的奇幻世界',
    platform: ['Windows', 'Android', 'iOS', 'PS5'],
    icon: 'ri-swap-box-line',
    updateDate: '2026-08-02',
  },
  {
    id: 'res-007',
    name: '360安全卫士极速版',
    version: 'v15.6.0',
    size: '72.1 MB',
    category: 'security',
    rating: 4.5,
    downloads: 456000,
    description: '轻量级安全防护软件，无广告纯净体验，全面保护电脑安全',
    platform: ['Windows'],
    icon: 'ri-shield-flash-line',
    updateDate: '2026-07-29',
  },
  {
    id: 'res-008',
    name: '百度网盘',
    version: 'v7.38.0',
    size: '156.8 MB',
    category: 'system-tools',
    rating: 4.3,
    downloads: 980000,
    description: '大容量云存储服务，支持文件同步、在线预览、多端访问，数据安全可靠',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-cloud-line',
    updateDate: '2026-08-04',
  },
  {
    id: 'res-009',
    name: 'Notion 桌面版',
    version: 'v3.8.0',
    size: '112.4 MB',
    category: 'office-software',
    rating: 4.8,
    downloads: 345000,
    description: '全能笔记与知识管理工具，支持数据库、看板、日历等多种视图，提升工作效率',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-sticky-note-line',
    updateDate: '2026-07-31',
  },
  {
    id: 'res-010',
    name: 'Figma 桌面版',
    version: 'v124.5.0',
    size: '198.6 MB',
    category: 'graphic-design',
    rating: 4.7,
    downloads: 267000,
    description: '云端协作UI设计工具，实时多人协作、组件变体、原型交互一站式设计平台',
    platform: ['Windows', 'macOS'],
    icon: 'ri-layout-line',
    updateDate: '2026-08-03',
  },
  {
    id: 'res-011',
    name: 'DaVinci Resolve 19',
    version: 'v19.0.1',
    size: '3.6 GB',
    category: 'video-editing',
    rating: 4.8,
    downloads: 198000,
    description: '好莱坞级专业调色与剪辑软件，免费版即拥有强大的剪辑、调色、音频和特效功能',
    platform: ['Windows', 'macOS', 'Linux'],
    icon: 'ri-contrast-2-line',
    updateDate: '2026-08-01',
  },
  {
    id: 'res-012',
    name: 'IntelliJ IDEA 社区版',
    version: 'v2024.2.0',
    size: '756.3 MB',
    category: 'dev-tools',
    rating: 4.8,
    downloads: 423000,
    description: 'JetBrains出品Java/Kotlin开发IDE，智能代码补全、重构工具、深度框架集成',
    platform: ['Windows', 'macOS', 'Linux'],
    icon: 'ri-braces-line',
    updateDate: '2026-07-28',
  },
  {
    id: 'res-013',
    name: '腾讯手游助手',
    version: 'v5.8.0',
    size: '18.5 MB',
    category: 'games',
    rating: 4.4,
    downloads: 756000,
    description: '官方手游模拟器，完美运行王者荣耀、和平精英等热门手游，键鼠操控更精准',
    platform: ['Windows'],
    icon: 'ri-smartphone-line',
    updateDate: '2026-08-02',
  },
  {
    id: 'res-014',
    name: '火绒安全软件',
    version: 'v6.0.2',
    size: '24.8 MB',
    category: 'security',
    rating: 4.7,
    downloads: 534000,
    description: '轻巧高效的国产安全软件，安静防护不打扰，弹窗拦截功能深受用户喜爱',
    platform: ['Windows'],
    icon: 'ri-fire-line',
    updateDate: '2026-08-04',
  },
  {
    id: 'res-015',
    name: '网易有道词典',
    version: 'v10.8.0',
    size: '134.2 MB',
    category: 'education',
    rating: 4.6,
    downloads: 645000,
    description: '专业翻译学习工具，支持多语种互译、OCR拍照翻译、AI写作批改等功能',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-translate',
    updateDate: '2026-08-05',
  },
  {
    id: 'res-016',
    name: 'Bandizip 专业版',
    version: 'v7.36',
    size: '6.8 MB',
    category: 'system-tools',
    rating: 4.8,
    downloads: 423000,
    description: '高速压缩解压工具，支持50+压缩格式，智能解压、密码管理和分卷压缩',
    platform: ['Windows', 'macOS'],
    icon: 'ri-folder-zip-line',
    updateDate: '2026-07-30',
  },
  {
    id: 'res-017',
    name: '石墨文档',
    version: 'v3.12.0',
    size: '89.7 MB',
    category: 'office-software',
    rating: 4.5,
    downloads: 312000,
    description: '云端协作办公平台，支持多人实时编辑、评论批注、版本历史等团队协作功能',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-article-line',
    updateDate: '2026-08-03',
  },
  {
    id: 'res-018',
    name: 'XMind 2024',
    version: 'v24.6.0',
    size: '165.3 MB',
    category: 'education',
    rating: 4.7,
    downloads: 287000,
    description: '专业思维导图工具，支持鱼骨图、矩阵图等多种结构，提升学习与工作效率',
    platform: ['Windows', 'macOS', 'Android', 'iOS'],
    icon: 'ri-mind-map',
    updateDate: '2026-08-01',
  },
  {
    id: 'res-019',
    name: 'PotPlayer 64位',
    version: 'v240618',
    size: '32.6 MB',
    category: 'video-editing',
    rating: 4.9,
    downloads: 567000,
    description: '全能视频播放器，支持几乎所有视频格式，硬件加速解码，流畅播放4K/8K视频',
    platform: ['Windows'],
    icon: 'ri-play-circle-line',
    updateDate: '2026-07-28',
  },
  {
    id: 'res-020',
    name: 'GitHub Desktop',
    version: 'v3.4.2',
    size: '128.5 MB',
    category: 'dev-tools',
    rating: 4.6,
    downloads: 389000,
    description: 'GitHub官方桌面客户端，可视化Git操作，简化代码托管和团队协作流程',
    platform: ['Windows', 'macOS'],
    icon: 'ri-git-branch-line',
    updateDate: '2026-08-02',
  },
];